import React from 'react'
import { useParams } from 'react-router-dom';
import GenBreadCrumb from './GenBreadCrumb';
import PowerGenerationTabs from './PowerGenerationTabs';

function PowerGeneration() {
    const { plantName, id } = useParams(); 
    return ( 
        <>
        <GenBreadCrumb plantName={decodeURIComponent(plantName)} />

        <PowerGenerationTabs plantId={id} />
        
        {/* <AdvertiseBanner /> */}
        </>
     );
}

export default PowerGeneration;